import React from 'react';
import { Search } from 'lucide-react';
import Logo from '../components/Logo';
import { TEN_SEAT_MARKETING_URL } from '../utils/seo';

/**
 * Marketplace page - temporarily hidden
 * The full marketplace functionality is commented out below for future use
 */

const Marketplace: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header with Logo */}
      <header className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-4 py-8">
          <div className="flex justify-center">
            <Logo size="xl" showText={false} />
          </div>
        </div>
      </header>

      {/* Main Content - Placeholder */}
      <main className="flex-1 flex items-center justify-center px-4">
        <div className="text-center max-w-md">
          <div className="mb-6">
            <Search className="w-16 h-16 mx-auto text-gray-300" aria-hidden="true" />
          </div>
          <h1 className="text-2xl font-semibold text-gray-900 mb-3">
            Ohow, you are looking for a restaurant?
          </h1>
          <p className="text-gray-600">
            This page is not available yet. Please check back later.
          </p>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200">
        <div className="container mx-auto px-4 py-6 text-center">
          <p className="text-sm text-gray-600">
            Powered by{' '}
            <a
              href={TEN_SEAT_MARKETING_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-primary-600 no-underline hover:opacity-80 transition-opacity focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600"
            >
              10Seat
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Marketplace;

